import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { toQuery, toMutation, nodeWithArgs } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import lodash from 'lodash';

export const LOAD_STUDY_ROLES = 'COMPLION_ADMIN_LOAD_STUDY_ROLES';
export const ADD_STUDY_ROLE = 'COMPLION_ADMIN_ADD_STUDY_ROLE';
export const REMOVE_ROLE = 'COMPLION_ADMIN_REMOVE_ROLE';
export const UPDATE_ROLE = 'COMPLION_ADMIN_UPDATE_ROLE';

export function loadStudyRoles(institutionId, checkCanDelete = false, includeInactive = false) {

    return (dispatch) => {
        const query = nodeWithArgs('rolesManagementForInstitution', {
            institutionId,
            checkCanDelete,
            includeInactive
        }, [
            'id',
            'name',
            'isSystem',
            'canDelete',
            'active'
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to retrieve roles for institution'));
            } else {
                const studyRoles = results.data.rolesManagementForInstitution;
                const nonSystemRoles  = lodash
                    .filter(studyRoles, role => role.isSystem === false)
                    .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
                const systemRoles = lodash
                    .filter(studyRoles, role => role.isSystem === true)
                    .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
                const newStudyRoles = lodash.concat(systemRoles, nonSystemRoles);

                dispatch({
                    type: LOAD_STUDY_ROLES,
                    payload: newStudyRoles,
                });
            }
        });
    };
}

export function addStudyRole(institutionId, name) {
    return (dispatch, getState) => {
        const query = nodeWithArgs('createRolesManagement', {
            institutionId,
            name,
            active: true
        }, [
            'id',
            'name',
            'isSystem',
            'active'
        ]);
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add role to institution'));
            } else {
                dispatch({
                    type: ADD_STUDY_ROLE,
                    payload: results.data.createRolesManagement,
                });
                dispatch(addApplicationMessage('success', 'Study Roles successfully updated.'));
            }
        });
    };
}

export function removeRole({ id, name }) {
    return (dispatch) => {
        if (name === 'Principal Investigator') {
            return dispatch(addApplicationMessage('error', '"Principal investigator" is a pre-defined role and cannot be removed.'));
        }
        const query = nodeWithArgs('deleteRolesManagement', {
            id,
        });
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to remove role'));
            }
            else {
                dispatch({
                    type: REMOVE_ROLE,
                    payload: { id, name },
                });
                dispatch(addApplicationMessage('success', 'Study Roles successfully updated.'));
            }
        });
    };
}

export function setRoleActive({ id, name }, { institutionId, viewerId }, setActive) {
    return (dispatch) => {
        const query = nodeWithArgs('updateRolesManagement', {
            id,
            institutionId,
            name,
            active: setActive,
            viewerId,
        },
        [
            'id',
            'name',
            'active'
        ]);
        const action = setActive ? 'activate' : 'deactivate';
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', `Failed to ${action} role`));
            }
            else {
                const updatedRole = results.data.updateRolesManagement;
                dispatch({
                    type: UPDATE_ROLE,
                    payload: { id: updatedRole.id, active: updatedRole.active },
                });
                
                dispatch(addApplicationMessage('success',`Study Role '${name}' successfully ${action}d.`));
            }
        });
    };
}